import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../Common';
import { toasty } from './forms/FormElements';

export const submitPickupTimesheet = async (pickupDetails) => {
    if (!pickupDetails.resources.some((rs) => rs.quantity > 0)) {
        toasty.error('At least one resource must have a pickup quantity greater than zero.');
        throw new Error('At least one resource must have a pickup quantity greater than zero.');
    }

    const response = await httpClient.post(
        ApiRoutes.timesheet.createPickupTimesheet(),
        {
            ...pickupDetails,
            resources: pickupDetails.resources.filter((rs) => rs.quantity > 0),
        },
        httpClient.format.none,
    );

    const serviceResponse = await response.json();
    if (!response.ok) {
        throw new Error(serviceResponse?.message || 'An error occurred while creating the timesheet.');
    }

    return serviceResponse.timesheetNumber;
};
